import { useEffect } from "react";
import { X } from "lucide-react";

export function Lightbox({
  open,
  src,
  alt,
  caption,
  onClose,
}: {
  open: boolean;
  src: string;
  alt: string;
  caption?: string;
  onClose: () => void;
}) {
  useEffect(() => {
    if (!open) return;
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") onClose();
    }
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-slate-950/95 p-4"
      onClick={onClose}
    >
      <button
        onClick={onClose}
        className="absolute right-4 top-4 rounded-full bg-white/10 p-2 text-white hover:bg-white/20"
        aria-label="Chiudi"
      >
        <X className="h-5 w-5" />
      </button>

      <img
        src={src}
        alt={alt}
        className="max-h-[85vh] max-w-full rounded-md object-contain shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      />
      {caption ? (
        <div className="mt-3 text-sm text-slate-300">{caption}</div>
      ) : null}
    </div>
  );
}
